import React from "react";

const PATIENT_STATUS = {
  ativo: { label: "Ativo", cls: "ds-badge-success", dot: "bg-[hsl(var(--success-text))]" },
  pendente: { label: "Pendente", cls: "ds-badge-warning", dot: "bg-[hsl(var(--warning-text))]" },
  inativo: { label: "Inativo", cls: "ds-badge-neutral", dot: "bg-[hsl(var(--text-tertiary))]" },
  bloqueado: { label: "Bloqueado", cls: "ds-badge-danger", dot: "bg-[hsl(var(--danger-text))]" },
  alta: { label: "Alta", cls: "ds-badge-info", dot: "bg-[hsl(var(--info-text))]" },
};

const APPT_STATUS = {
  agendado: { label: "Agendado", cls: "ds-badge-neutral" },
  confirmado: { label: "Confirmado", cls: "ds-badge-info" },
  realizado: { label: "Realizado", cls: "ds-badge-success" },
  cancelado: { label: "Cancelado", cls: "ds-badge-danger" },
  falta: { label: "Falta", cls: "ds-badge-warning" },
};

export function PatientStatusBadge({ status }) {
  const m = PATIENT_STATUS[status] || PATIENT_STATUS.ativo;
  return (
    <span className={`ds-badge ${m.cls}`} data-testid={`patient-status-${status}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${m.dot}`} />
      {m.label}
    </span>
  );
}

export function AppointmentStatusBadge({ status }) {
  const m = APPT_STATUS[status] || APPT_STATUS.agendado;
  return (
    <span className={`ds-badge ${m.cls}`} data-testid={`appt-status-${status}`}>
      {m.label}
    </span>
  );
}
